import React from "react";
import { Search } from "react-feather";
import { Field, Icon, Input } from "./KgNodeSearchField.styles";

export interface KgNodeSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const KgNodeSearchField: React.FC<KgNodeSearchFieldProps> = ({
  value,
  onChange,
  placeholder = "Search nodes",
  className,
}) => (
  <Field className={className}>
    <Icon aria-hidden>
      <Search size={16} />
    </Icon>
    <Input
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={placeholder}
    />
  </Field>
);

export default KgNodeSearchField;
